<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon
            class="fill-default"
            points="2560 0 2560 100 0 100"
          ></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="5" md="7">
          <b-card no-body class="bg-secondary border-0 mb-0">
            <b-card-body class="px-lg-5 py-lg-5">
              <div class="text-center text-muted mb-4">
                <h2>{{ $t("message.forgot") }}</h2>
              </div>
              <validation-observer
                v-slot="{ handleSubmit }"
                ref="formValidator"
              >
                <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <base-input
                    alternative
                    class="mb-3"
                    name="Email"
                    :rules="{ required: true, email: true }"
                    prepend-icon="ni ni-email-83"
                    :placeholder="$t('message.email')"
                    v-model="model.email"
                  >
                  </base-input>

                  <label v-if="wrongemail" style="color:red;"
                    >{{ $t("message.wrongemail") }}</label
                  >
                  <div class="text-center">
                    <base-button
                      type="primary"
                      native-type="submit"
                      class="my-4"
                      >{{ $t("message.change_password") }}</base-button
                    >
                  </div>
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import Vue from "vue";
import VueCookies from "vue-cookies";
import qs from "qs";
import axios from "axios";
import VueAxios from "vue-axios";

Vue.use(VueCookies);
Vue.use(VueAxios, axios);
//Vue.$cookies.config("30d");

export default {
  data() {
    return {
      model: {
        email: ""
      },
      wrongemail: false
    };
  },
  methods: {
    onSubmit() {
      //console.log(this.model.email);
      //console.log(this.model.password);
      Vue.axios
        .post(
          "/app/reset_password",
          qs.stringify({
            username: this.model.email
          })
        )
        .then(({ data }) => {
          if (data.status == 1) {
            this.wrongemail = false;
            console.log("Password resetted Yay!");
            this.$router.push({ name: "login" });
          } else {
            //show error
            this.wrongemail = true;
            console.log("login issue");
          }
        });
    }
  }
};
</script>
<style scoped>
.bg-gradient-success {
  background: linear-gradient(87deg, #e9ecef, #5da0e3) !important;
}
</style>
